import { Box } from '@factorialco/deprecated-design-system'
import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import EffectiveOnField from '../../../Blocks/BasicInformation/EffectiveOnField'
import OwnerField from '../../../Blocks/BasicInformation/OwnerField'
import Category from '../../../Blocks/Category'
import { CustomizationProps } from '../../../withCustomizationFields'
import { PermissionsProps } from '../../../withFieldPermissions'
import FormBlock from '../../FormBlock'

interface Props extends PermissionsProps, CustomizationProps {
  onEmployeeIdChange: (employeeId: number | undefined) => void
  isAutomaticExpensable: boolean
  hasReportOnBehalfFeature: boolean
  canCreateExpensesForOthers: boolean
  canSeeEmployeeLegalEntity: boolean
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
  onEffectiveOnChange: (value: string) => void
}

const ExpenseInformation = (props: Props) => {
  const {
    canSeeEmployeeLegalEntity,
    isAutomaticExpensable,
    currentEmployee,
    onEmployeeIdChange,
    hasReportOnBehalfFeature,
    canCreateExpensesForOthers,
    resourceType,
  } = props

  return (
    <FormBlock
      title={i18n.t('expenses_v2.forms.new_form.blocks.expense_information')}
      subtitle={i18n.t('expenses_v2.forms.new_form.blocks.expense_information_subtitle')}
    >
      <Box gap="s24">
        <OwnerField
          {...props}
          currentEmployee={currentEmployee}
          showEmployeeLegalEntity={canSeeEmployeeLegalEntity}
          isAutomaticExpensable={isAutomaticExpensable}
          onEmployeeIdChange={onEmployeeIdChange}
          hasReportOnBehalfFeature={hasReportOnBehalfFeature}
          canCreateExpensesForOthers={canCreateExpensesForOthers}
        />
        <Category {...props} />
        <EffectiveOnField {...props} fieldIdentifier="effective_on" resourceType={resourceType} />
      </Box>
    </FormBlock>
  )
}

export default ExpenseInformation
